import React from 'react';
import { Spin, Typography } from 'antd';
import type { AdminProductMaterialLoadingProps } from '../../interfaces';

import './AdminProductMaterialLoading.scss';

const { Text } = Typography;

const AdminProductMaterialLoading: React.FC<AdminProductMaterialLoadingProps> = ({ loading }) => (
  <div className="admin-product-form__material-details-loading">
    <Spin size="small" spinning={loading} />
    <Text type="secondary">
      {loading ? 'Loading material controls...' : 'Open to load material controls.'}
    </Text>
  </div>
);

export default AdminProductMaterialLoading;
